import React from 'react';
import {
  Drop,
  Barbell,
  PawPrint,
  Sparkle,
  Tree,
  Lightning,
} from '@phosphor-icons/react';
import ServicePage from './ServicePage';

const facilities = [
  { icon: Drop, label: 'Swim sessions', sub: 'Shallow, supervised splash pool' },
  { icon: Barbell, label: 'Agility course', sub: 'Tunnels, ramps and jumps' },
  { icon: Lightning, label: 'Sprint runs', sub: 'Open ground for high-energy bursts' },
  { icon: Tree, label: 'Sensory garden', sub: 'Scent trails and varied textures' },
  { icon: PawPrint, label: 'Enrichment toys', sub: 'Rotated puzzles and games' },
  { icon: Sparkle, label: 'Cool-down zone', sub: 'Shaded rest before heading home' },
];

const gallery = [
  {
    url: 'https://images.unsplash.com/photo-1591946614720-90a587da4a36?auto=format&fit=crop&w=1200&q=80',
    title: 'Swim time',
    description: 'Hydrotherapy-friendly splash sessions.',
  },
  {
    url: 'https://images.pexels.com/photos/1108099/pexels-photo-1108099.jpeg?auto=compress&cs=tinysrgb&w=1200',
    title: 'Agility play',
    description: 'Confidence-building obstacle courses.',
  },
  {
    url: 'https://images.unsplash.com/photo-1477884213360-7e9d7dcc1e48?auto=format&fit=crop&w=1200&q=80',
    title: 'Open grounds',
    description: 'Wide, fenced runs for free movement.',
  },
];

const highlights = [
  'Sessions adjusted to age and fitness level',
  'Towel-dry and cool-down after every swim',
  'Non-slip flooring on the agility course',
  'Quiet exit area for sensitive dogs',
];

const Recreation = () => (
  <ServicePage
    eyebrow="Recreation"
    title="Active days, happy dogs"
    lede="Swim, sprint, climb and explore — recreation built for dogs who need more than a walk."
    heroImage="https://images.unsplash.com/photo-1505628346881-b72b27e84530?auto=format&fit=crop&w=2000&q=80"
    heroAlt="Dog running in an open field"
    intro="Recreation is where energy meets variety. Our spaces are designed to challenge body and mind — gentle introductions for first-timers, structured sessions for regulars, and always a quiet cool-down to finish."
    facilities={facilities}
    gallery={gallery}
    highlights={highlights}
    closingTitle="Movement they actually enjoy"
    closingBody="Whether your dog loves the water, the chase or a good puzzle, there’s a recreation track that fits them."
  />
);

export default Recreation;
